module.exports = __webpack_public_path__ + "static/assets/af518b342146d46befc2c532d90648ad.svg";